"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSnackbar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledSnackbar = _styledComponents.default.div.withConfig({
  displayName: "Snackbarstyles__StyledSnackbar",
  componentId: "sc-1277ho1-0"
})(["font-family:'Gilroy';padding:10px 24px;box-sizing:border-box;border-radius:10px;font-size:1rem;letter-spacing:0.02em;min-height:60px;display:flex;align-items:center;", ";", ";", ";", ";", ";", ";", ";&.notification,&.message{box-shadow:0px 5px 20px rgba(115,127,143,0.1);}.row{display:flex;align-items:center;height:100%;width:100%;svg{vertical-align:top;}.icon{margin-right:16px;}.dismiss{margin-left:16px;cursor:pointer;}.col-middle{flex:0 1 100%;}}.sb-custom{display:flex;align-items:center;.col{&.left{flex-basis:100%;p{margin:0px;color:#ffffff;}}&.right{display:flex;align-items:center;justify-content:space-between;button{margin-left:8px;white-space:nowrap;}}}}"], ({
  backgroundColor
}) => `background-color: ${backgroundColor};`, ({
  textColor
}) => `color: ${textColor};`, ({
  height
}) => `
      height: ${height};
  `, ({
  zIndex
}) => zIndex && `z-index: ${zIndex}`, ({
  width
}) => `
      width: ${width};
  `, ({
  isHighEmphasis,
  textColor
}) => `
    .dismiss {
      path {
        fill: ${isHighEmphasis ? '#ffffff' : textColor || _shared.theme.palette.brand.primary.charcoal};
      }
    }
  `, ({
  isFloating,
  show,
  zIndex
}) => isFloating && `
    position: absolute;
    opacity: 0;
    top: -200px;
    ${zIndex && `z-index: ${zIndex}`};

    &.top {
      &-left {
        left: 20px;
      }
      &-center {
        left: 50%;
        transform: translateX(-50%);
      }
      &-right {
        right: 20px;
      }
    }

    ${show && `
      &.animate {
        opacity: 1;
        transition-property: opacity, top, bottom, left, right, width, margin, border-radius;
        transition-duration: 0.5s;
        transition-timing-function: ease;
        top: 70px;

        &.fadeout {
          opacity: 0;
        }
      }
    `}
  `);

exports.StyledSnackbar = StyledSnackbar;